import script from "./AppChrome.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppChrome.vue?vue&type=script&lang=ts&setup=true"

import "./AppChrome.vue?vue&type=style&index=0&id=01426094&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01426094"]])

export default __exports__